import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { frontendNotification } from '../../Notification';
import { SidebarItem, SidebarItemITF } from '../types';

import { getPathURL } from '../../../utils/helpers';
import * as s from './styles';
import Tooltip from '../../Tooltip';

export const RenderItems = ({
  item,
  isSidebarOpen,
  closeSidebar,
  forceShowSubItems
}: SidebarItemITF) => {
  const [showSubnav, setShowSubnav] = useState(false);

  const toggleShowSubnav = () => setShowSubnav(!showSubnav);

  const navigate = useNavigate();
  const { t } = useTranslation();

  // Quando forceShowSubItems é true (durante busca), mostrar subitens automaticamente
  useEffect(() => {
    if (forceShowSubItems && item.sidebarSubItems && item.sidebarSubItems.length > 0) {
      setShowSubnav(true);
    } else if (!forceShowSubItems) {
      // Fechar quando a busca é limpa (opcional - pode remover se quiser manter aberto)
      // setShowSubnav(false);
    }
  }, [forceShowSubItems, item.sidebarSubItems]);

  const handleClick = (menu: SidebarItem) => {
    if (menu.disabled) {
      return frontendNotification({
        message: t(menu.disabled),
        type: 'warning',
      });
    }

    if (menu.sidebarSubItems) {
      return toggleShowSubnav();
    }

    if (menu.path && !menu.disabled) {
      if (window.screen.width < 900) {
        closeSidebar();
      }
      return navigate(menu.path);
    }

    return null;
  };

  const handleArrowitem = () => {
    if (item.sidebarSubItems && showSubnav) {
      return <HiChevronUp />;
    }
    if (item.sidebarSubItems) {
      return <HiChevronDown />;
    }
    return null;
  };

  const visibleSubItems = item.sidebarSubItems?.filter(subItem => subItem.show) || [];

  return (
    <>
      <Tooltip title={isSidebarOpen ? '' : t(item.title)}>
        <s.SidebarItemContainer
          onClick={() => handleClick(item)}
          isSidebarOpen={isSidebarOpen}
          isPathSelected={item.path === getPathURL()}
        >
          {item.icon && (
            <div id="sidebar-item-icon">
              <item.icon />
            </div>
          )}
          <div id="sidebar-item-title">
            <p>{t(item.title)}</p>
          </div>

          <div id="sidebar-item-arrow">{handleArrowitem()}</div>
        </s.SidebarItemContainer>
      </Tooltip>

      {showSubnav && visibleSubItems.length > 0 && (
        <s.SubItemsContainer isOpen={showSubnav}>
          {visibleSubItems.map((subItem) => (
            <Tooltip
              key={subItem.title}
              title={isSidebarOpen ? '' : t(subItem.title)}
            >
              <s.SidebarSubItemContainer
                onClick={() => handleClick(subItem)}
                isSidebarOpen={isSidebarOpen}
                isPathSelected={subItem.path === getPathURL()}
              >
                {subItem.icon && (
                  <div id="sidebar-item-icon">
                    <subItem.icon />
                  </div>
                )}
                <div id="sidebar-item-title">
                  <p>{t(subItem.title)}</p>
                </div>
              </s.SidebarSubItemContainer>
            </Tooltip>
          ))}
        </s.SubItemsContainer>
      )}
    </>
  );
};

export default RenderItems;
